import classNames from 'classnames';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useState } from 'react';
import './index.scss';

export interface EcoBlogItemProps extends ImgVideoProps, EcoTabItemProps {}

export interface EcoTabImgProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 列表
     */
    items?: EcoBlogItemProps[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 * tab切换(纯图片)
 */
const EcoTabImg: React.FC<EcoTabImgProps> = ({ theme = 'white', className, ...reset }) => {
    const props = reset || {};
    const prefixCls = `eco-tab-img`;
    const classes = classNames(prefixCls, 'eco-content', {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });
    const items = props.items || [];
    const defaultItem = items[0] || {};
    const [activeItem, setActiveItem] = useState(defaultItem);

    // 切换
    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveItem(items[index]);
    };
    return (
        <div className={classes}>
            <div className={`${prefixCls}-img`}>
                <EcoImgVideo isVideo={activeItem.isVideo} pc={activeItem.pc} h5={activeItem.h5} loop={true} />
            </div>
            <div className={`${prefixCls}-tab`}>
                <EcoTab onChange={toggleItemHandle} items={items} theme={theme} />
            </div>
        </div>
    );
};

export default EcoTabImg;
